export default __webpack_public_path__ + "static/media/Mobile Demand.fc085401.png";